'use client'
import {
  __spreadValues
} from "./chunk-UYSR6ZT4.mjs";

// src/components/round-robin/utils.ts
var teamPairs = [
  ["home_team", "away_team"],
  ["second_home_team", "second_away_team"],
  ["third_home_team", "third_away_team"],
  ["fourth_home_team", "fourth_away_team"]
];
var extractMatchData = (events) => {
  var _a, _b;
  const teamsMap = /* @__PURE__ */ new Map();
  const matchMap = /* @__PURE__ */ new Map();
  for (const event of events) {
    for (const [home, away] of teamPairs) {
      if (!((_a = event == null ? void 0 : event[home]) == null ? void 0 : _a._id) || !((_b = event == null ? void 0 : event[away]) == null ? void 0 : _b._id)) continue;
      teamsMap.set(event[home]._id, __spreadValues({}, event[home]));
      teamsMap.set(event[away]._id, __spreadValues({}, event[away]));
      matchMap.set(`${event[home]._id}::${event[away]._id}`, {
        homeScore: Number(event[home].score) || 0,
        awayScore: Number(event[away].score) || 0
      });
    }
  }
  return { teams: Array.from(teamsMap.values()), matchMap };
};

export {
  extractMatchData
};
//# sourceMappingURL=chunk-52IPYQXN.mjs.map